import React from 'react';
import Link from 'gatsby-link';
import styled from 'react-emotion';
import tinycolor from 'tinycolor2';

const PageContent = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
`;

export default PageContent;


// WEBPACK FOOTER //
// ./src/components/Common/PageContent/index.js